import { isValidSnils } from '../../../hooks/useForm'
import type { ExtractionStage } from '../../../api/listeners/document-extraction'

const unconfirmedLinks = new Set(['person_link_unconfirmed', 'document_link_unconfirmed'])

export const normalizeExtractedSnils = (value: string): string | null => {
    const text = value.normalize('NFKC').trim()
    if (!/^[0-9\s\-‐‑‒–—−]+$/.test(text)) return null
    const digits = text.replace(/\D/g, '')
    if (!/^\d{11}$/.test(digits) || /^0+$/.test(digits)) return null
    const formatted = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 9)} ${digits.slice(9)}`
    return isValidSnils(formatted) ? formatted : null
}

export const recognizedSnilsNumbers = (stage: ExtractionStage | null): { numbers: string[]; needsReview: boolean } => {
    const numbers: string[] = []
    let needsReview = false
    if (!stage || !['succeeded', 'failed'].includes(stage.status)) return { numbers, needsReview }
    for (const part of stage.parts) {
        if (part.status !== 'succeeded' || !part.result) continue
        for (const document of part.result.documents) {
            if (document.type !== 'snils') continue
            const field = document.fields.find(item => item.name === 'number')
            if (!field || (!field.rawValue?.trim() && !field.normalizedValue?.trim())) continue
            const raw = field.rawValue?.trim() ? normalizeExtractedSnils(field.rawValue) : null
            const normalized = field.normalizedValue?.trim() ? normalizeExtractedSnils(field.normalizedValue) : null
            const number = normalized || raw
            const conflicting = part.result.conflicts.some(conflict => !unconfirmedLinks.has(conflict.code)
                && conflict.fields.some(ref => ref.documentId === document.documentId && ref.field === 'number'))
                || part.result.unresolved.some(item => !unconfirmedLinks.has(item.code) && item.documentId === document.documentId && item.field === 'number')
            if (!number || field.status !== 'extracted' || field.candidates.length || conflicting
                || ['failed', 'invalid', 'conflict'].includes(field.validation.format)
                || ['failed', 'invalid', 'conflict'].includes(field.validation.crossDocument)
                || (field.rawValue?.trim() && !raw) || (field.normalizedValue?.trim() && !normalized)
                || (raw && normalized && raw !== normalized)) {
                needsReview = true
                continue
            }
            if (!numbers.includes(number)) numbers.push(number)
        }
    }
    return { numbers, needsReview }
}
